import { Component, ViewEncapsulation, Input, ViewChild, ElementRef } from '@angular/core';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperScrollbarInterface, SwiperNavigationInterface, SwiperAutoplayInterface } from 'ngx-swiper-wrapper';

import { ResortSummary } from '../../models/presentation.model';
import { OvsComponent } from '../../shared/core/ovs.core';
import { ResortComponent } from '../../shared/resort.component';

import { SearchEvents, SearchResultEvents } from '../../instrumentation/resort-instrumentation.module';
import { UserActivityLogger, UserActivityLoggerOptions } from '../../instrumentation/user-activity-logger.service';

@Component({
  selector: 'resort-listing-carousel',
  templateUrl: './resort-listing-carousel.component.html',
  styleUrls: ['./resort-listing-carousel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResortListingCarouselComponent extends ResortComponent
{
    @Input("resort") 
    public resort: ResortSummary = new ResortSummary();
    private _swiper: any;
    @ViewChild("swiper")
    private _swiperElementRef: ElementRef;

    constructor(){
        super();
    }

    protected initialize(): void
    {
        super.initialize();
    }

    public ngAfterViewInit(): void {
        let element: any = this._swiperElementRef.nativeElement;
        const swipeConfig: SwiperConfigInterface = {
            direction: 'horizontal',
            loop: false,
            autoplay: false,
            navigation: {
                nextEl: '.main-swiper__btn--next',
                prevEl: '.main-swiper__btn--prev',
            },
            autoHeight: true,
        };
        this._swiper = new Swiper(element, swipeConfig);
    }

    public swipe(): void{
        UserActivityLogger.logEvent(SearchResultEvents.ResortImageArrowClicked, { resortId: this.resort.id, isPreferred: true }, UserActivityLoggerOptions.AppInsightsOnly);
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-listing/resort-listing-carousel/resort-listing-carousel.component.ts